module.exports = __webpack_public_path__ + "img/scene1-5.ffd1b7e6.png";